var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-footer-shell"},[_c('home-footer',{on:{"license":_vm.openLicense}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }